<template>
  <div class="app-property">
    <label class="app-property__label">{{ property.label }}</label>

    <div v-if="property.type == 'text'" class="app-property__input-wrapper">
      <a-input v-if="!property.attributes.isLong" v-model="computedValue"></a-input>
      <a-textarea v-else v-model="computedValue" :autosize="{ minRows: 2, maxRows: 6 }"></a-textarea>
    </div>

    <div v-else-if="property.type == 'number'" class="app-property__input-wrapper">
      <a-input-number
        v-model="computedValue"
        :min="property.attributes.min || 0"
        :max="property.attributes.max || 100"
      ></a-input-number>
    </div>

    <div v-else-if="property.type == 'select'" class="app-property__input-wrapper">
      <a-select
        v-model="computedValue"
        showSearch
        placeholder="Select"
        :mode="property.attributes.multiple ? 'multiple' : 'default'"
      >
        <a-select-option
          v-for="item in property.attributes.options"
          :key="item"
          :value="item"
        >{{item}}</a-select-option>
      </a-select>
    </div>

    <div v-else-if="property.type == 'datasource'" class="app-property__input-wrapper">
      <a-select
        v-if="datasource"
        v-model="computedValue"
        showSearch
        placeholder="Select"
        mode="default"
      >
        <a-select-option
          v-for="item in datasource.items"
          :key="`datasource-${property.attributes.datasourceId}-item-${item.id}`"
          :value="item.id"
        >
          <div
            v-if="property.attributes.allowEdit"
            class="_d-flex _content-center-v _content-between-h"
          >
            <div>{{ item.data[datasource.titleField] }}</div>
            <div>
              <a class="_p-0" @click.prevent.stop="datasourceItemEdit(item)">
                <font-awesome-icon :icon="[_app.iconStyle, 'pencil']"/>
              </a>
            </div>
          </div>
        </a-select-option>
      </a-select>

      <div v-if="property.attributes.allowCreate">
        <a-button class="_w-100 _m-t-1" size="small" @click="datasourceItemEdit()">
          <font-awesome-icon :icon="[_app.iconStyle, 'plus']" class="_m-r-1"/>Add
        </a-button>
      </div>

      <a-modal title="Item Editor" v-model="isVisible.dsItemEditor" :footer="null">
        <app-edit-item
          v-if="currentDatasourceItem"
          :datasource="datasource"
          :item="currentDatasourceItem"
          @afterSave="datasourceItemSaved"
        ></app-edit-item>
      </a-modal>
    </div>

    <div v-else-if="property.type == 'rating'" class="app-property__input-wrapper">
      <a-rate v-model="computedValue"></a-rate>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "app-property",
  props: {
    property: {
      type: Object
    },
    propertyData: {
      type: null
    }
  },
  data() {
    return {
      newValue: this.propertyData,
      datasource: null,

      currentDatasourceItem: null,

      isVisible: {
        dsItemEditor: false
      }
    };
  },
  watch: {
    // newValue: _.debounce(function(val) {
    //   this.$emit("change", val);
    // }, 500),
    propertyData(value) {
      this.newValue = value;
    }
  },
  methods: {
    datasourceItemEdit(item = null) {
      if (!item) {
        this.currentDatasourceItem = {
          data: {}
        };
      } else {
        this.currentDatasourceItem = item;
      }
      this.isVisible.dsItemEditor = true;
    },
    datasourceItemSaved(item) {
      if (!item.id) {
        this.datasource.items.push(item);
      }
      this.isVisible.dsItemEditor = false;
      this.currentDatasourceItem = null;
    }
  },
  computed: {
    selectedBooth() {
      return this.$store.state.selectedBooth;
    },

    // datasourceItems() {

    // },

    computedValue: {
      get() {
        // return (
        //   (this.currentLevel.schema.data[this.selectedBooth] &&
        //     this.currentLevel.schema.data[this.selectedBooth][
        //       this.propertyId
        //     ]) ||
        //   null
        // );

        return this.newValue;
      },
      set(value) {
        // this.$store.commit("level/UPDATE_SCHEMA_PROPERTY", {
        //   boothId: this.selectedBooth,
        //   id: this.propertyId,
        //   value: value
        // });
        this.newValue = value;

        this.$emit("change", value);
      }
    }
  },
  async created() {
    if (this.property.type == "datasource") {
      const datasource = await this.$store.dispatch("datasource/fetchSingle", {
        id: this.property.attributes.datasourceId,
        include: "items"
      });

      this.$set(this, "datasource", datasource);
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.app-property {
  margin-bottom: $--size-2;

  &__label {
    display: block;
    margin-bottom: 3px;
  }
  &__input-wrapper {
    display: flex;
    flex-direction: column;

    > * {
      flex: 1;
    }
  }
}
</style>

